<template>
  <div>
    <gsp-select
      ref="fieldRef"
      :value="value"
      @change="value = $event.target.value"
      @blur="onBlur"
      :class="{ 'gsp-select-error': isFieldInvalid }"
      :disabled="disabled"
      :aria-labelledby="instanceId + '-aria-label'"
      :aria-describedby="instanceId + '-select-error'"
    >
      <label slot="end" :id="instanceId + '-aria-label'">
        <slot name="label" />
      </label>
      <slot />
    </gsp-select>
    <gsp-select-error-message role="alert" :id="instanceId + '-select-error'">
      <template v-if="isFieldInvalid">
        {{ errorMessage }}
      </template>
      <template v-else>&nbsp;</template>
    </gsp-select-error-message>
  </div>
</template>

<script>
let instanceCount = 0;
</script>

<script setup>
import initValidationField, {
  fieldProps,
  fieldEmits,
} from "~/composables/validation-field";
import { ref } from "vue";

let fieldRef = ref(null);

const instanceId = `select-${instanceCount++}`;

const props = defineProps({
  ...fieldProps,
});

const emit = defineEmits({
  ...fieldEmits,
});

const { value, isFieldInvalid, errorMessage, onBlur } = initValidationField({
  props,
  emit,
  fieldRef,
});
</script>
